export default () => ({
  shoppingCart: null,
  requestSource: null,
  editOrderId: undefined,
  orderCart: null,
});
